const progressBar = document.querySelector('.rsoc-load-progress');
let progress = 0;
let progressUpdateInterval;

const showPageContents = () => {
  const { body } = document;

  if (progressBar) {
    progressBar.style.width = '100%';
  }

  if (body?.classList.contains('fade-in-experiment')) {
    body.classList.remove('fade-in-experiment');
  }

  clearInterval(progressUpdateInterval);
};

const updateProgress = () => {
  if (progress >= 100) {
    clearInterval(progressUpdateInterval);

    return;
  }

  progress += 15;

  progressBar.style.width = `${progress}%`;
};

const delayLoad = () => {
  if (progressBar) {
    progressUpdateInterval = setInterval(updateProgress, 300);
    const forceVisibilityTimer = setTimeout(showPageContents, 2000);
    window.addEventListener('rampJsUnitLoaded', (e) => {
      console.log(e);
      showPageContents();
      clearTimeout(forceVisibilityTimer);
    });
  } else {
    showPageContents();
  }
};

export default delayLoad;
